import "./log.css";
import * as React from "react";
import * as echarts from "echarts";
import { RootState } from "../../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ClipboardJS from "clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MuscleData, IconsItem } from "../report/postureMuscle";
import userLogoIcon from "../../../assets/reportIcon/userLogoIcon.png";
import userSexIcon from "../../../assets/reportIcon/userSexIcon.png";
import userAgeIcon from "../../../assets/reportIcon/userAgeIcon.png";
import userHeightIcon from "../../../assets/reportIcon/userHeightIcon.png";
import userWeightIcon from "../../../assets/reportIcon/userWeightIcon.png";

import middleRiskBg from "../../../assets/reportIcon/middleRiskBg.png";
import highRiskBg from "../../../assets/reportIcon/highRiskBg.png";
import normalRiskBg from "../../../assets/reportIcon/normalRiskBg.png";

import arrow from "../../../assets/reportIcon/arrow.png";

import { message, Input, Divider } from "antd";
import { PostureData, formatData } from "../report/postureData";
import {GetPostureReportResponse, PostureService, RiskResult} from "../../../core/adapters";
import { CanvasEnum } from "../report/muscle";
import { RiskCanvas } from "../report/riskCanvas";
import { RiskDetailCanvas } from "../report/riskDetailCanvas";
import { analysisConclusion, getRiskByMuscleKey } from "../report/advice";
import {
  getReportPageDataByUuidAndExamineeId,
  GetReportPageDataByUuidAndExamineeIdArgs,
  saveExaminerResultAndUpdateExamination,
  SaveExaminerResultAndUpdateExamination,
  ReportData,
  updatePosturePoints,
  getExaminerResult,
} from "../../../core/actions/institution";
import { DotData, Direction } from "../report/postureData.type";
// @ts-ignore
import {ExaminationService, ExaminerResult} from "../../../core/adapters";
import MuscleCom from "../report/muscleCom";
import { useIntl, FormattedMessage } from "react-intl";
const { TextArea } = Input;
var _ = require("lodash");
import logo from "../../../assets/images/logo_xz.png";
import moment from "moment";
import axios from "axios";
import UrlUtils from "../../../utils/url";
import loading from "../../../assets/images/loading.gif";
import {post, url} from "../../../assets/javascripts/http";
import { getLanguageCode } from "../../../assets/javascripts/intl";
import AppReportHead from "../report/AppReportHead";
let examinationService = new ExaminationService(url, post);
let postureService = new PostureService(url, post);
export interface ReportStateProps {
  posture: GetPostureReportResponse;
  frontRisks: Array<IconsItem>;
  examinerResult: Array<ExaminerResult>;
  examinerItem: ExaminerResult;
  sideRisks: Array<IconsItem>;
  backRisks: Array<IconsItem>;
  risks: Array<RiskResult>;
  risksLabels: Array<any>;
  reportPageData: ReportData;
  postureFrontData: Object;
  postureSideData: Object;
  postureBackData: Object;
  user: Array<any>;
  postureData: any;
  currentCanvasId: string;
  doctorMsg: string;
  diagnosisName: string;
  slide: boolean;
  show: boolean;
  scale: number;
  scaleBig: number;
  showModel: boolean;
  isSave: boolean;
  riskItem: RiskResult;
  isShowRiskDetail: boolean;
  currentImg: HTMLImageElement;
  frontImg: HTMLImageElement;
  sideImg: HTMLImageElement;
  backImg: HTMLImageElement;
  doctorName: string;
  width: number;
  height: number;
  clientHeight: number;
  clientWidth: number;
  orgName: string;
  language: string;
  isDown: boolean;
  reloadCount: number;
  intervalId: any;
  organizationLogo: string;
}
export interface ReportDispatchProps {
  getReportPageDataByUuidAndExamineeId(args: GetReportPageDataByUuidAndExamineeIdArgs): void;
  updatePosturePoints(args: GetPostureReportResponse): void;
  saveExaminerResultAndUpdateExamination(args: SaveExaminerResultAndUpdateExamination): void;
  getExaminerResult(): void;
}
export interface ReportProps {
  reportPageData: ReportData;
  institution: any;
  examinerResult: Array<ExaminerResult>;
}

interface RouteParams {
  uuid: string;
}
type PropsType = RouteComponentProps<RouteParams> & ReportProps;

class Report extends React.Component<PropsType & ReportDispatchProps, ReportStateProps> {
  currentPosture: PostureData = Object.assign({});

  state: ReportStateProps = {
    riskItem: Object.assign({}),
    examinerItem: Object.assign({}),
    currentImg: Object.assign({}),
    posture: Object.assign({}),
    reportPageData: Object.assign({ doctorName: "" }),
    frontRisks: [],
    examinerResult: [],
    isShowRiskDetail: false,
    show: false,
    showModel: false,
    clientHeight: 500,
    clientWidth: 500,
    isSave: false,
    scale: 0.6,
    scaleBig: 1,
    sideRisks: [],
    backRisks: [],
    currentCanvasId: "front",
    risks: [],
    risksLabels: [],
    postureFrontData: {},
    postureSideData: {},
    postureBackData: {},
    postureData: {},
    doctorName: "",
    user: [
      {
        name: <FormattedMessage id="name" />,
        icon: userLogoIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="gender" />,
        icon: userSexIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="age" />,
        icon: userAgeIcon,
        value: "value",
        unit: <FormattedMessage id="year" />,
      },
      {
        name: <FormattedMessage id="height" />,
        icon: userHeightIcon,
        value: "value",
        unit: "cm",
      },
      {
        name: <FormattedMessage id="weight" />,
        icon: userWeightIcon,
        value: "value",
        unit: "kg",
      },
      {
        name: <FormattedMessage id="time" />,
        icon: userWeightIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="patientId" />,
        icon: userWeightIcon,
        value: "value",
        unit: "",
      },
    ],
    doctorMsg: "",
    slide: false,
    diagnosisName: "",
    frontImg: Object.assign({}),
    sideImg: Object.assign({}),
    backImg: Object.assign({}),
    width: 0,
    height: 0,
    orgName: "",
    language: "",
    isDown: true,
    reloadCount: 0,
    intervalId: 0,
    organizationLogo: "",
  };
  async componentWillMount() {
  }
  onSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    let slide = !this.state.slide;
    this.setState({ slide });
  };
  isReportCompleted = (postureData) => {
    let tempDownState;
    if (postureData.status == 'PROCESSING' && postureData.resultPosture == "NULL") {
      this.setState({
        isDown: false,
        reloadCount: this.state.reloadCount+1
      });
      tempDownState = false;
    } else {
      this.setState({
        isDown: true,
        reloadCount: this.state.reloadCount+1
      });
      tempDownState = true;
    }
    if (this.state.reloadCount > 3) {
      clearInterval(this.state.intervalId)
    }
    return tempDownState;
  };

  checkReportExists = async () => {
    let that = this, pageData;
    let uuid = this.props.match.params.uuid;
    let examinationReport = await examinationService.getExaminationReportByExamineeReportDetailId({
      examineeReportDetailId: uuid,
    });
    await postureService.getPostureReport({
      uuid: examinationReport.examinationReportResult.examineeReportDetailId || "",
      language: getLanguageCode(),
    }, UrlUtils.isTrial() ? examinationReport.examinationReportResult.examinerAccountId : undefined).then(function (res) {
      pageData = res
      that.isReportCompleted(res)
    });
    return pageData;
  }

  startInterval=()=>{
    const id = setInterval(() => {
      this.checkReportExists()
      if (this.state.isDown) {
        window.location.href = window.location.href + "&editable=true"
        clearInterval(this.state.intervalId)
      }
    }, 5000);
    this.setState({
      intervalId: id
    });
  }

  componentDidMount() {
  }

  componentWillReceiveProps(props) {
    const url = new URL(location.href);
    let lang = url.searchParams.has("language") ? url.searchParams.get("language")! : "en";
    let _this = this;
    let reportPageData: ReportData = props.reportPageData;
    let examineeId = reportPageData.examinationReportResult?.examineeResult?.examineeId
    let examinerResult = props.examinerResult;
    let status = this.isReportCompleted(reportPageData.postureData)
    if (!status){
      this.startInterval()
    }
    const clipboard = new ClipboardJS(".copy");

    clipboard.on("success", function (e) {
      toast.success("复制成功!");
      console.log("success");
    });

    this.setState({
      language: (function () {
        return lang;
      })(),
    });
    let orgId = reportPageData.examinationReportResult && reportPageData.examinationReportResult.organizationId;
    this.getExaminationReportPageByExamineeIdAndType(examineeId,0,100, orgId, lang)
    axios
      .post(`https://api.xingzheng.tech/base.organization.OrganizationService/GetOrganizationByIds`, {
        ids: reportPageData.examinationReportResult && reportPageData.examinationReportResult.organizationId,
      })
      .then((res) => {
        const data = res.data.organizations || [];
        this.setState({
          orgName: data[0] && data[0].name,
          organizationLogo: data[0] && data[0].organizationLogo,
        });
      });
    this.setUserInfo(reportPageData);
    let institution = props.institution || {};
    let realName = institution.realName || "";
    this.setState({
      reportPageData,
      doctorMsg: reportPageData.doctorMsg,
      doctorName: realName,
      examinerResult: examinerResult,
    });
    if (reportPageData.update) {
      this.setState({
        show: false,
      });
    }
  }

  setUserInfo = (reportPageData: ReportData) =>{
    let gen = {
      GENDER_UNKNOWN: "未知",
      MALE: <FormattedMessage id="male" />,
      FEMALE: <FormattedMessage id="female" />,
    };
    let examineeResultJson: any = {};
    if (reportPageData.examinationReportResult && reportPageData.examinationReportResult.examineeResult) {
      let examineeResultStr = JSON.stringify(reportPageData.examinationReportResult.examineeResult)
      examineeResultJson = JSON.parse(examineeResultStr)
    }
    let user = this.state.user;
    let originUser = reportPageData.user || {};
    user[0]["value"] = originUser.name;
    user[1]["value"] = gen[originUser.gender] || "未知";
    user[2]["value"] = originUser.age || 0;
    user[3]["value"] = originUser.heightScalar || 0;
    user[4]["value"] = originUser.weightScalar || 0;
    user[5]["value"] = reportPageData.reportGenDate || "";
    user[6]["value"] = examineeResultJson.patientId || "";
    this.setState({
      user: user
    });
  }

  getExaminationReportPageByExamineeIdAndType = (examineeId, pNum, pSize, orgId, language) => {
    axios
        .post(`https://api.xingzheng.tech/base.examination.ExaminationService/GetExaminationReportPageByExamineeIdAndType`, {
          examineeId: examineeId,
          examinationReportType: "POSTURE",
          pageNum: pNum,
          pageSize: pSize,
        })
        .then((res) => {
          console.log(res)
          let reportResultsObj = {}, reportListObj = {}
          res.data.examinationReportResults.forEach(item => {
            reportResultsObj[item.examineeReportDetailId] = moment(+item.creationTimestamp).format("YYYY-MM-DD HH:mm:ss")
          })
          console.log(reportResultsObj)
          const uuids = res.data.examinationReportResults.map((item) => item.examineeReportDetailId);
          console.log(uuids)
          axios
              .post(`https://api.xingzheng.tech/algorithm.posture.PostureService/GetPostureReportList`, {
                uuid: uuids,
                language: language,
                organizationId: orgId,
                isSave: false,
              })
              .then((res) => {
                console.log(res)
                res.data.postureReportList.forEach(item => {
                  if (item.body){
                    reportListObj[item.uuid] = item.body
                  }
                })
                console.log(reportListObj)
                let dataResult = {'front':{},'side':{}, 'back':{}}
                Object.keys(reportResultsObj).forEach(key => {
                  Object.keys(dataResult).forEach(typeKey => {
                    if (reportListObj[key]){
                      reportListObj[key][typeKey].risks.forEach(risk => {
                        if (!dataResult[typeKey][risk.key]) {
                          dataResult[typeKey][risk.key] = {
                            name:risk.name,
                            raw:[risk.raw],
                            value:[risk.value],
                            time:[reportResultsObj[key]]
                          }
                        } else {
                          dataResult[typeKey][risk.key].name = risk.name
                          dataResult[typeKey][risk.key].raw.push(risk.raw)
                          dataResult[typeKey][risk.key].value.push(risk.value)
                          dataResult[typeKey][risk.key].time.push(reportResultsObj[key])
                        }
                      })
                    }

                  })
                  this.setState({
                    postureFrontData:dataResult['front'],
                    postureSideData:dataResult['side'],
                    postureBackData:dataResult['back']
                  })
                })
                Object.keys(dataResult['front']).forEach(key => {
                  let id = 'front_' + key + '_line_id';
                  this.createLineChart(id, dataResult['front'][key]);
                })
                Object.keys(dataResult['side']).forEach(key => {
                  let id = 'side_' + key + '_line_id';
                  this.createLineChart(id, dataResult['side'][key]);
                })
                Object.keys(dataResult['back']).forEach(key => {
                  let id = 'back_' + key + '_line_id';
                  this.createLineChart(id, dataResult['back'][key]);
                })
                console.log(dataResult)
              });
        });
  }

  createLineChart = (id, data) =>{
    console.log(data)
    const barDom: any = document.getElementById(id)
    let myChart = echarts.init(barDom)
    myChart.clear();
    const option: any = {
      tooltip: {
        trigger: 'axis',
        position: function (pt) {
          return [pt[0], '10%'];
        }
      },
      title: {
        left: 'center',
        text: ''
      },
      grid: {
        top: '10%',
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: true,
        data: data.time
      },
      yAxis: {
        type: 'value',
        boundaryGap: true
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 20
        },
        {
          start: 0,
          end: 20
        }
      ],
      series: [
        {
          name: 'Fake Data',
          type: 'line',
          smooth: true,
          data: data.value
        }
      ]
    };
    myChart.setOption(option)
  }

  readonlyUrl = () => {
    const url = new URL(location.href);
    url.searchParams.delete("editable");
    return url.toString();
  };

  goBack = () => {
    window.history.back()
  }

  onShowDetail = () => {
    let isShowRiskDetail = this.state.isShowRiskDetail;
    this.setState({ isShowRiskDetail: !isShowRiskDetail });
  };

  draw = async (reportPageData: ReportData) => {
    let scale = 1;
    let gen = {
      GENDER_UNKNOWN: "未知",
      MALE: <FormattedMessage id="male" />,
      FEMALE: <FormattedMessage id="female" />,
    };
    let examineeResultJson: any = {};
    if (reportPageData.examinationReportResult && reportPageData.examinationReportResult.examineeResult) {
      let examineeResultStr = JSON.stringify(reportPageData.examinationReportResult.examineeResult)
      examineeResultJson = JSON.parse(examineeResultStr)
    }
    let user = this.state.user;
    let originUser = reportPageData.user || {};
    user[0]["value"] = originUser.name;
    user[1]["value"] = gen[originUser.gender] || "未知";
    user[2]["value"] = originUser.age || 0;
    user[3]["value"] = originUser.heightScalar || 0;
    user[4]["value"] = originUser.weightScalar || 0;
    user[5]["value"] = reportPageData.reportGenDate || "";
    user[6]["value"] = examineeResultJson.patientId || "";

    let res = reportPageData.postureData;
    if (!res) {
      return;
    }

    let frontUrl = res.front || "";
    let sideUrl = res.side || "";
    let backUrl = res.back || "";

    if (res.body && res.body) {
      let facePointsMin = formatData({ data: res, direction: "front" });

      let sidePointsMin = formatData({ data: res, direction: "side" });

      let backPointsMin = formatData({ data: res, direction: "back" });

      let frontImg = new Image();
      frontImg.src = frontUrl;
      frontImg.onload = () => {
        let drawCanvasFace = new PostureData({
          canvasId: "front",
          img: frontImg,
          data: facePointsMin,
          directon: "front",
          risks: res.body,
        });
        let w = frontImg.width;
        let h = frontImg.height;
        let clientHeight = window.screen.availHeight * 0.76;
        let clientWidth = window.screen.availWidth * 0.76;

        this.setState({
          width: w,
          clientHeight,
          clientWidth,
          height: h,
        });
      };
      this.setState({ frontImg: frontImg });

      let sideImg = new Image();
      sideImg.src = sideUrl;
      sideImg.onload = () => {
        let drawCanvas = new PostureData({
          canvasId: "side",
          img: sideImg,
          data: sidePointsMin,
          directon: "side",
          risks: res.body,
        });
      };
      this.setState({ sideImg: sideImg });

      let backImg = new Image();
      backImg.src = backUrl;
      backImg.onload = () => {
        let drawCanvasback = new PostureData({
          canvasId: "back",
          img: backImg,
          data: backPointsMin,
          directon: "back",
          risks: res.body,
        });
      };
      this.setState({ backImg: backImg });
      let muscleData = new MuscleData(res);
      let risks = muscleData.getRiskData();

      let risksLabelSet = new Set();
      let risksLabelArray: any = [];
      risks.filter((item) => {
        if (item.level == "severe") {
          risksLabelSet.add("high");
        }
        if (item.level == "mild") {
          risksLabelSet.add("middle");
        }
        if (item.level == "normal") {
          risksLabelSet.add("normal");
        }
      });
      risksLabelSet.forEach((item) => {
        if (item == "high") {
          risksLabelArray[2] = item;
        }
        if (item == "middle") {
          risksLabelArray[1] = item;
        }
        if (item == "normal") {
          risksLabelArray[0] = item;
        }
      });
      this.setState({
        risks: risks,
        risksLabels: risksLabelArray,
        user: user,
        posture: res,
      });
      console.log(res);
      new RiskCanvas(res);
    }
  };
  onDoctorMsg = (e) => {
    let msg = e.target.value;
    this.setState({
      doctorMsg: msg,
    });
  };
  onSetDiagnosisName = (e) => {
    let doctorName = e.target.value;
    this.setState({
      doctorName,
    });
  };
  printPDF = () => {
    window.print();
  };
  onRefresh = () =>{
    window.location.reload();
  };
  onSaveData = (tag: string) => {
    if (tag == "print") {
      const { user, reportPageData } = this.state;
      // let user = this.state.user;
      let obj =
        user.filter((s) => {
          return s.name == "姓名";
        })[0] || {};
      let time = reportPageData.examinationReportResult.creationTimestamp || 0;
      let timeStr = moment(+time).format("YYYYMMDDHHmmss") || "";
      document.title = "体态报告-" + user[0].value + "-" + timeStr;
      this.printPDF();
      setTimeout(() => {
        document.title = "体态报告";
      }, 1000);
    } else {
      let data: any = {
        examinerResult: {
          ...this.state.examinerItem,
          name: this.state.doctorName,
        },
        doctorAdvice: this.state.doctorMsg,
      };
      this.props.saveExaminerResultAndUpdateExamination(data);
    }
  };
  onChangeCurrentCanvasId = (currentCanvasId: CanvasEnum) => {
    let reportPageData = this.state.reportPageData || {};
    this.setState({ currentCanvasId });
    let data: DotData[] = formatData({ data: reportPageData.postureData, direction: currentCanvasId });
    let img = this.state.frontImg;
    if (currentCanvasId == "back") {
      img = this.state.backImg;
    }
    if (currentCanvasId == "front") {
      img = this.state.frontImg;
    }
    if (currentCanvasId == "side") {
      img = this.state.sideImg;
    }
    let show = this.state.show;

    this.setState(
      {
        currentImg: img,
        show: !show,
        isSave: false,
        showModel: false,
        scaleBig: 1,
      },
      () => {
        let c: any = currentCanvasId + "big";
        this.currentPosture = new PostureData({
          canvasId: c,
          img: img,
          data: data,
          directon: currentCanvasId,
          risks: reportPageData.postureData.body,
          width: this.state.clientWidth,
          height: this.state.clientHeight,
        });
      }
    );
  };
  onClosePosture = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    let showModel = this.state.showModel;
    let isSave = this.state.isSave;
    let show = true;
    if (isSave) {
      show = false;
    }
    this.setState({
      show: show,
      showModel: !showModel,
    });
  };
  onUpdateSaveStatus = () => {
    let isSave = !this.state.isSave;
    this.setState({
      isSave: isSave,
    });
  };
  onSetRiskItem = (riskItem: RiskResult) => {
    let key = riskItem.key + riskItem.direction;
    let detaiKey = key + "detail";

    let reportPageData = this.state.reportPageData || {};
    this.setState(
      {
        riskItem,
      },
      () => {
        try {
          new RiskDetailCanvas(reportPageData.postureData, riskItem);
        } catch (error: any) {
          console.log(error);
        }
      }
    );
    this.onShowDetail();
  };
  onCancle = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      isSave: false,
      showModel: false,
    });
  };
  onOk = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      isSave: false,
      showModel: false,
      show: false,
    });
  };
  onUpdatePoint = () => {
    let orginPoints: any = this.state.posture;
    let currentPosture = this.currentPosture;
    let currentPoints = window["pointList"];
    let scaleX = this.currentPosture.scaleX;
    let scaleY = this.currentPosture.scaleY;

    orginPoints = _.cloneDeep(orginPoints);
    currentPoints = _.cloneDeep(currentPoints);

    currentPoints.forEach((point) => {
      let partDirection = point.partDirection;
      let position = point.position;
      position.x = position.x / scaleX;
      position.y = position.y / scaleY;
      let name = point.name;
      let direction: Direction = point.direction;
      if (orginPoints.body && orginPoints.body[direction] && orginPoints.body[direction].points) {
        if (partDirection && partDirection.length) {
          orginPoints.body[direction].points[name][partDirection] = position;
        } else {
          orginPoints.body[direction].points[name] = position;
        }
      }
    });
    // console.log({orginPoints})
    this.props.updatePosturePoints(orginPoints);
  };
  onExaminerItem = (examinerItem: ExaminerResult) => {
    this.setState({
      examinerItem: examinerItem,
      doctorName: (examinerItem.name as any) || "",
      slide: false,
    });
  };
  onSavaPostureData = () => {
    message.success({ content: "保存成功", duration: 3 });
    this.setState({
      isSave: true,
    });
  };
  onCancleUpdatePoint = () => {
    this.setState({ show: false });
  };
  // 放大
  onZoomIn = () => {
    let scaleBig = this.state.scaleBig + 0.1;
    this.setState({
      scaleBig,
    });
    this.currentPosture.setScale(scaleBig, true);
  };
  // 缩小
  onZoomOut = () => {
    let scaleBig = this.state.scaleBig - 0.1;
    this.setState({
      scaleBig,
    });
    this.currentPosture.setScale(scaleBig, true);
  };

  render() {
    let postureData: any = localStorage.getItem("angles") || {};

    let historyList = [];
    let postureFrontData = this.state.postureFrontData;
    let postureSideData = this.state.postureSideData;
    let postureBackData = this.state.postureBackData;

    let clientHeight = this.state.clientHeight;
    let clientWidth = this.state.clientWidth;

    let mt = 0;
    let logo = this.state.organizationLogo;
    let editable = UrlUtils.getQueryParameter("editable");
    if (editable == null) {
      editable = UrlUtils.getQueryParameter("isSave");
    }
    let isSave = editable == "true";
    let orgName = this.state.orgName;
    let isDown = this.state.isDown;
    return (
        <>
          {
            !isDown && (
                <div className="loading-style">
                  <img src={loading} width={200}/>
                  <div>
                    <FormattedMessage id="loading" />
                  </div>
                </div>
            )
          }
          {
            isDown &&
            (<div className="appReport appReportGait" id="appReport">
        <div className="print-firstPage">
          <div className={this.state.show ? "bigContext hideIn" : "bigContext hideOn"}>
            <div className="scaleText">
              <FormattedMessage id="movePosition" />
            </div>
            <div className="saveAndCancle">
              {isSave && (
                <div onClick={this.onUpdatePoint} className="savaData">
                  <FormattedMessage id="saveModify" />
                </div>
              )}
              <div onClick={this.onCancleUpdatePoint} className="canclesavaData">
                <FormattedMessage id="cancel" />
              </div>
              <div onClick={this.onZoomIn} className="canclesavaData">
                <FormattedMessage id="zoomIn" />
              </div>
              <div onClick={this.onZoomOut} className="canclesavaData">
                <FormattedMessage id="zoomOut" />
              </div>
            </div>
          </div>
          {/* 标题和个人信息 */}
        <AppReportHead orgName={orgName} organizationLogo={logo} user={this.state.user} />
        </div>
        <div className="appReportRiskEvalute">
                <div className="appDataHead">
                  <div className="appDataRect"></div>
                  <div className="appDataText">
                    <FormattedMessage id="postureData"></FormattedMessage>
                  </div><a onClick={this.goBack.bind(this)} style={{position: 'absolute',right:'15px'}}><FormattedMessage id="returnToReport" /></a>
                </div>
                <div className="riskLevelType">
                  <div key={'front'} className={"riskLevelTypeItem"}>
                    <Divider orientation="left" className={"print-none"}>
                      <FormattedMessage id="front" />
                    </Divider>
                    <div className={"riskList"}>
                      {Object.keys(postureFrontData).map((key) => {
                        return (
                            <div
                                key={`front_${key}_key`}
                                className={"riskEvaluteLogItem riskEvalute"}
                            >
                              <div className={"riskEvaluteLogItemLevel"}>{postureFrontData[key].name}</div>
                                <div id={`front_${key}_line_id`} key={`front_${key}_line_key`}  style={{width:'100%',height:'150px'}}></div>
                            </div>
                        );
                      })}
                    </div>
                  </div>
                  <div key={'side'} className={"riskLevelTypeItem"}>
                    <Divider orientation="left" className={"print-none"}>
                      <FormattedMessage id="side" />
                    </Divider>
                    <div className={"riskList"}>
                      {Object.keys(postureSideData).map((key) => {
                        return (
                            <div
                                key={`side_${key}_key`}
                                className={"riskEvaluteLogItem riskEvalute"}
                            >
                              <div className={"riskEvaluteLogItemLevel bg"}>{postureSideData[key].name}</div>
                                <div id={`side_${key}_line_id`} key={`side_${key}_line_key`} style={{width:'100%',height:'150px'}}></div>
                            </div>
                        );
                      })}
                    </div>
                  </div>
                  <div key={'back'} className={"riskLevelTypeItem"}>
                    <Divider orientation="left" className={"print-none"}>
                      <FormattedMessage id="back" />
                    </Divider>
                    <div className={"riskList"}>
                      {Object.keys(postureBackData).map((key) => {
                        return (
                            <div
                                key={`back_${key}_key`}
                                className={"riskEvaluteLogItem riskEvalute"}
                            >
                              <div className={"riskEvaluteLogItemLevel bg"}>{postureBackData[key].name}</div>
                              <div id={`back_${key}_line_id`} key={`back_${key}_line_key`} style={{width:'100%',height:'150px'}}></div>
                            </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
        <p className="media-print text-foot">
          准确性声明: 本系统作为专业人士辅助评估工具，其评估结论不可直接作为诊断结论
        </p>

        <ToastContainer />
      </div>)
          }
        </>
    );
  }
}

function mapStateToProps(state: RootState): ReportProps {
  return {
    reportPageData: state.institution.reportPageData,
    examinerResult: state.institution.examinerResult,
    institution: state.institution.institution,
  };
}
function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): ReportDispatchProps {
  return {
    updatePosturePoints(args) {
      dispatch(updatePosturePoints(args));
    },
    getReportPageDataByUuidAndExamineeId(args) {
      dispatch(getReportPageDataByUuidAndExamineeId(args));
    },
    saveExaminerResultAndUpdateExamination(args) {
      dispatch(saveExaminerResultAndUpdateExamination(args));
    },
    getExaminerResult() {
      dispatch(getExaminerResult());
    },
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Report) as any);
